require('../bootstrap');

import env from '../config/loadEnv';
import router from '../router/index'

const baseURL = env.baseURL;
const normalURL = env.normalURL;

const store = {
    state: {
        user: {
            name: '',
            picture: '',
            job: '',
            email: '',
            id: 0
        },
        authenticated: false,
        token: '',
        api: baseURL,
        url: normalURL,
        breadcrumbs: [{ name: "Home", route: "/" }],
        packageVersion: process.env.PACKAGE_VERSION || '0'
    },
    getters: {
        appVersion: (state) => {
            var pjson = require('../../package.json');
            return pjson.version
        },
        token: state => {
            return state.token;
        },
        authenticated: state => {
            if (state.token == null || state.token == 'null') {
                return false;
            }

            return state.authenticated;
        },
        logo: state => {
            return state.logo;
        },
        user: state => {
            return state.user;
        },
        api: state => {
            return state.api;
        },
        breadcrumbs: state => {
            return state.breadcrumbs;
        }
    },
    mutations: {
        auth(state, token) {
            console.log(token)
            console.log(state)
            if (token != null && token != undefined) {
                state.authenticated = true;
                state.token = token;

                localStorage.clear();
                localStorage.setItem('token', token);

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.commit('profileUpdate');
            }
        },
        profileUpdate(state) {
            axios.post(state.api + 'me', {
                token: state.token
            })
                .then(response => {
                    state.user.id = response.data.id;
                    state.user.name = response.data.name;
                    state.user.email = response.data.email;
                    state.user.picture = response.data.photo;
                    state.user.is_dev = response.data.is_dev;
                    state.user.is_QA = response.data.is_QA;
                    state.user.is_deployer = response.data.is_deployer;
                    state.user.is_admin = response.data.is_admin ? 1 : 0;
                    state.user.switch = response.data.switch  ? 1 : 0;
                    console.log(response.data)

                    localStorage.setItem('is_dev', response.data.is_dev);
                    localStorage.setItem('is_QA', response.data.is_QA);
                    localStorage.setItem('is_deploy', response.data.is_deployer);
                    localStorage.setItem('is_admin', response.data.is_admin);
                    localStorage.setItem('switch', response.data.switch);
                })
                .catch(error => {
                    localStorage.clear();

                    router.push('/login');
                });
        },
        updateBreadCrumbs(state, newRoute) {
            if (state.breadcrumbs.length > 1) {
                state.breadcrumbs.pop();
            }
            state.breadcrumbs.push(newRoute)
            // state.breadcrumbs = newRoute;
        }
    },
    actions: {
        initialize(context) {
            const token = localStorage.getItem('token');

            context.commit('auth', token);
        }
    }
};

export default store;
